import _defineProperty from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { isApolloError } from '@apollo/client';
import { isError } from './utils.js';
/** Checks if error is Apollo Error, and checks if error codes match */

var isApolloErrorWithOneOfCodes = function isApolloErrorWithOneOfCodes(err) {
  var _a, _b;

  if (isError(err) && isApolloError(err)) {
    if (err.graphQLErrors.length) {
      var errorCode = (_b = (_a = err.graphQLErrors[0]) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.code;

      for (var _len = arguments.length, codes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        codes[_key - 1] = arguments[_key];
      }

      return !!errorCode && codes.includes(errorCode);
    }
  }

  return false;
};
/** Checks if error is Apollo Network Error with a status code */


var isApolloNetworkErrorWithStatusCode = function isApolloNetworkErrorWithStatusCode(err) {
  return isError(err) && isApolloError(err) && !!err.networkError && "statusCode" in err.networkError;
};
/** Checks if error is Apollo Network Error and checks if status code matches any of provided */


var isApolloNetworkErrorWithOneOfStatusCodes = function isApolloNetworkErrorWithOneOfStatusCodes(err) {
  for (var _len2 = arguments.length, statusCodes = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    statusCodes[_key2 - 1] = arguments[_key2];
  }

  return isApolloNetworkErrorWithStatusCode(err) && statusCodes.includes(err.networkError.statusCode);
};
/**
 * Updates cache of a query by adding `createdObject` to the query. Used after mutation that
 * creates/adds a new object.
 *
 * @param apolloCache Can be found in mutation _update_ method parameter
 * @param query The query result cache which needs to be updated. This query should return a List of
 *   objects or if `toUpdateListName` is specified, query should return with object with
 *   `toUpdateListName` that has array value
 * @param createdObject Created object to add to query result
 * @param options Optional config options
 * @param options.queryVariables Query variables used on the query
 * @param options.toUpdateListName If the cache array we want to update is nested inside query data
 * @param options.unshift Moves createdObject to the begging of the query result instead of the end
 */


var updateCacheAfterAdd = function updateCacheAfterAdd(apolloCache, query, createdObject, options) {
  var _ref = options || {},
      queryVariables = _ref.queryVariables,
      toUpdateListName = _ref.toUpdateListName,
      unshift = _ref.unshift;

  var current = apolloCache.readQuery({
    query: query,
    variables: queryVariables
  });
  if (!current) return;
  var updatedData = {}; // eslint-disable-line

  Object.keys(current).forEach(function (queryName) {
    var queryData = current[queryName];
    if (isArrayResult(queryData)) queryData = unshift ? [createdObject].concat(_toConsumableArray(queryData)) : [].concat(_toConsumableArray(queryData), [createdObject]);else if (typeof queryData !== "string" && toUpdateListName && isArrayResult(queryData[toUpdateListName])) queryData = Object.assign(Object.assign({}, queryData), _defineProperty({}, toUpdateListName, unshift ? [createdObject].concat(_toConsumableArray(queryData[toUpdateListName])) : [].concat(_toConsumableArray(queryData[toUpdateListName]), [createdObject])));else throw new Error("Missing valid toUpdateListName option");
    updatedData[queryName] = queryData;
  });
  apolloCache.writeQuery({
    query: query,
    variables: queryVariables,
    data: updatedData
  });
};
/**
 * Updates cache of a query by deleting object with deleteId from the query. Used after mutation
 * that deletes/removes an object.
 *
 * @param apolloCache Can be found in mutation _update_ method parameter
 * @param query The query result cache which needs to be updated. This query should return a List of
 *   objects or if `toUpdateListName` is specified, query should return with object with
 *   `toUpdateListName` that has array value
 * @param deleteId Id of deleted object to remove from query result
 * @param options Optional config options
 * @param options.queryVariables Query variables used on the query
 * @param options.toUpdateListName If the cache array we want to update is nested inside query data
 */


var updateCacheAfterRemove = function updateCacheAfterRemove(apolloCache, query, // query result cache which needs to be updated
deleteId, options) {
  var _ref2 = options || {},
      queryVariables = _ref2.queryVariables,
      toUpdateListName = _ref2.toUpdateListName;

  var current = apolloCache.readQuery({
    query: query,
    variables: queryVariables
  });
  if (!current) return;
  var updatedData = {}; // eslint-disable-line

  Object.keys(current).forEach(function (queryName) {
    var queryData = current[queryName];
    if (isArrayResult(queryData)) queryData = queryData.filter(function (a) {
      return a._id !== deleteId;
    });else if (typeof queryData !== "string" && toUpdateListName && isArrayResult(queryData[toUpdateListName])) queryData = Object.assign(Object.assign({}, queryData), _defineProperty({}, toUpdateListName, queryData[toUpdateListName].filter(function (a) {
      return a._id !== deleteId;
    })));else throw new Error("Missing valid toUpdateListName option");
    updatedData[queryName] = queryData;
  });
  apolloCache.writeQuery({
    query: query,
    variables: queryVariables,
    data: updatedData
  });
};

var isArrayResult = function isArrayResult(data) {
  return Array.isArray(data);
};

export { isApolloErrorWithOneOfCodes, isApolloNetworkErrorWithOneOfStatusCodes, isApolloNetworkErrorWithStatusCode, updateCacheAfterAdd, updateCacheAfterRemove };